export default __webpack_public_path__ + "static/conferences-cde59a07412c6228f9b9ea73d5eafa25.png";